import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useBlockWindowOverflow } from 'app/hooks'

import { Button, IonIcon } from 'controls'

import styles from './styles'

const BaseDrawer = ({
  isOpen,
  isFullScreen,
  size,
  className,
  icon,
  header,
  children,
  onClose
}) => {
  useBlockWindowOverflow(isOpen)

  return (
    <section
      className={classnames('base-drawer-container', className, size, {
        'is-open': isOpen,
        isFullScreen
      })}
    >
      <div className="content">
        {header && <header className="header">{header}</header>}

        <Button className="close-button" onClick={onClose}>
          {icon || <IonIcon icon="md-close" />}
        </Button>

        {children}
      </div>

      <style jsx>{styles}</style>
    </section>
  )
}

BaseDrawer.defaultProps = {
  isFullScreen: true,
  size: 'normal'
}

BaseDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool,
  size: PropTypes.oneOf(['normal', 'big']),
  className: PropTypes.string,

  header: PropTypes.any,
  icon: PropTypes.any,
  children: PropTypes.any
}

export default BaseDrawer
